import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  section: {
    gap: theme.spacings.md,
    marginTop: theme.spacings.lg,
  },
  sectionTitle: {
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  required: {
    color: colors.newUI.therapist.red70,
  },
  sectionDescription: {
    fontSize: theme.fontSizes.sm,
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  typeSelection: {
    marginTop: theme.spacings.md,
    gap: theme.spacings.sm,
  },
  typeItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacings.md,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacings.md,
    paddingVertical: theme.spacings.lg,
  },
});
